import React, { useRef, useState } from "react";
import Banner from "../../banner/index";
import ExportBotBand from "../../exportBotBand/index";
import Filters from "../../Filters/index";
import Botcard from "../../botStoreCard/index";
import Dbotcard from "../../dynamicBotCard";
import styles from "../../../styles/pages/botStore.module.scss";
import Icons from "../../../public/assets/svg/index";
import { getBotsAction, getFilterBotsAction } from "../../../redux/storeBot/actions";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroller";
import { useRouter } from "next/router";
import _ from "lodash";
import endpoints from "../../../utility/endpoints";
import axios from "axios";
import _get from "lodash/get";
import Loader from "../../Loader";
import MobileFilters from '../../MobileFilters'


function index(props) {


  const dispatch = useDispatch();
  const myScroll = useRef(null);

  const router = useRouter();
  const { data } = props;
  const bannerData = _.get(data[0], "component.content", "")
  //  const {component : {content }} = data[1]
  const content = _.get(data[1], "component.content", "");
  // _.get(data[2], "component.content.field_no_result_image[0].file_url", "")
  let initialStates = {};
  let [state, setState] = React.useState(initialStates);

  let [allBots, setAllBots] = React.useState([]);
  let [filters, setFilters] = React.useState([]);
  const [filterOn, setFilterOn] = useState(false);
  const [hasMore, setHasMore] = React.useState(true);
  const [filterActive, setFilterActive] = React.useState(false)
  const [auth, setAuth] = useState({});
  const [infiniteKey, setInfiniteKey] = React.useState(1)
  const [noResultFlag, setNoResultFlag] = React.useState(false)

  const [nonRestrictedUser, setnonRestrictedUser] = useState([
    "admin",
    "internalUser",
    "qrManager",
    "supportStatus"
  ]);


  
  const [filterStateExport, setfilterStateExport] = useState({})
  const [loadState, setLoadState] = React.useState(false);
  const [hasMoreBots, setHasMoreBots] = React.useState(true);
  const [length, setLength] = useState(0);
  const [loading, setLoading] = React.useState(false);
  const [mobileFilterRelatedInfo, setMobileFilterRelatedInfo] = React.useState({})
  const [ totalIndexFilter ,setTotalIndexFilter ] = React.useState(0)
  const [ currentFilters ,setCurrentFilters ] = React.useState({})
  const [reset,setReset] = React.useState(false)

  
  React.useEffect(async () => {
   // state = { ...router.query };
    setLoading(true);  
    dispatch(getBotsAction(0));

    try {
      if (localStorage.getItem("auth") != undefined) {
        setAuth(JSON.parse(localStorage.getItem("auth").data));
      }
    } catch (e) {}
  }, []);




  React.useEffect(() => {
    

    //console.log(state, "statefirst")
    let Filters = {};
    for (let i in state) {
      if (state[i]) {
        if (state[i].length > 0) {
          Filters[i] = state[i];
        }
      }
    }
    setfilterStateExport(Filters);
    
      
    if (
      Filters &&
      Object.keys(Filters).length === 0 &&
      Filters.constructor === Object
    ) {
      if (props.storeBot.filter !== null){
      window.scrollTo(0,200)
    }
      setLoading(true);  
      setInfiniteKey(infiniteKey+1)
      dispatch(getBotsAction(0))
      setHasMoreBots(true)
      setLoadState(true)
      setSearch("")
     
    }
  
  else {
    setLoading(true);  
    setInfiniteKey(infiniteKey+1)
    setHasMoreBots(true)
    setLoadState(true)
    window.scrollTo(0,200)
    if(Filters['catalogueProducts']){
      Filters['catalogueProducts']=Filters['catalogueProducts']=="Yes"?"true":"false"
    }
    setCurrentFilters(Filters)
    dispatch(getFilterBotsAction(0, Filters));
    
  }
  
  
    }, [state]);


  React.useEffect(() => {
   // if (props.storeBot.type == "all") {
  //  setLoading(false);
 
      if (props.storeBot.allBots && props.storeBot.filter !== null) {
        if(props.storeBot.allBots.length == 0){
          setNoResultFlag(true)
        }
        setLoading(false);
        setTotalIndexFilter(props.storeBot.totalIndex)
        setAllBots([...props.storeBot.allBots]);
        setHasMoreBots(true)
        setLoadState(true);
        if (state.search && state.search.length > 0) {
          inputRef.current.focus() 
        }
       // setInfiniteKey(infiniteKey+1)
       
      }
  //  }
  
  }, [props.storeBot]);



 



 

  const loadFunc = (a) => {
        //console.log(props.storeBot.totalIndex, "totalIndex")
        if (allBots.length < totalIndexFilter) {
          setHasMoreBots(true)
          setLoadState(true)
          if (!props.storeBot.filter)  {
      
            dispatch(getBotsAction(a));
            setLoadState(false)
          }
          else {
         
            dispatch(getFilterBotsAction(a, currentFilters))
            setLoadState(false)
          }
       
        } else {
        //  setLoadState(false)
          setHasMoreBots(false)
         // setHasMoreBots(false)
        }
  };



  const clearALLFilter = () => {
    window.scrollTo(0,200)
    setState({})
    //setLoadState(true)
    setNoResultFlag(false)
   
    
   // dispatch(getBotsAction(0))
   // setAllBots([])
   // setInfiniteKey(infiniteKey + 1)
   // setHasMoreBots(true)
    
    
  };
  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }


  const removeFilter = (keyname) => {
    if(keyname=="leadPlatform"){
      setReset(true)
      let otherState = mobileFilterRelatedInfo
      delete otherState['Area']
      setMobileFilterRelatedInfo({...otherState})
    }
    let stateToChange = state
   let itemToBeRemoved =  content.field_bot_store_filters_fields.filter((item) => item.value == keyname)
   if (itemToBeRemoved.length>0) {
    if (itemToBeRemoved[0].field_related_dropdown){
      delete stateToChange[camelize(itemToBeRemoved[0].field_related_dropdown)]
    }
   
   }
   

   delete stateToChange[keyname]
    
    setState({ ...stateToChange});
    if (length > 0){
      setLength(length-1);
    }
   
  };

  const inputRef = useRef(null)
  const [reload, setReload] = useState(false);
  const [search, setSearch ] = useState(state.search)

  React.useEffect(() => {
    if(reload) {   
    setState({ ...state, ["search"]: search });
    setReload(false)
     
   }
    
  }, [reload]);

  const callApi = () => { setReload(true) }; // You might be able to call API directly here, I haven't tried
  const [debouncedCallApi] = useState(() => _.debounce(callApi, 800));

  const inputChange = (e) => {
    if (e.target.value.length == 0) {
      //  console.log(e.target.value, "before");
      let statess = state;
      delete statess.search;
      setSearch("")
      setState({...statess})
      if (_.isEmpty(statess)) {
        clearALLFilter();
       
      }
    } else {
   
    setSearch( e.target.value)
    debouncedCallApi()
    
    }
  
  };

  // console.log("statestate", state);
  return (
    <>
      <div key={infiniteKey}>
        <InfiniteScroll
        key = {infiniteKey}
          pageStart={0}
          loadMore={loadState ? loadFunc : null}
          hasMore={hasMoreBots}
          loader={
            <div className={styles.loader}>
              <div className={styles.spinner}></div>
            </div>
          }
        >
          <div className={styles.storeContainer}>
            <Banner data={bannerData}/>
            <ExportBotBand userRole={props.userRole} filters={filterStateExport} setLoading = {setLoading}/>
            <div className={`${styles.search} container`}>
              <Icons name="searchGrayIcon" className={styles.searchIcon} />
              <input
                 type="text"
                 placeholder={_.get(props, "data[1].component.content.field_bot_store_filters_fields[0].field_title", "")}
                 onChange={inputChange}
                 name="search"
                  value={
                   search ? search : ""
                  }
                  ref = {inputRef}
             
              />
           
             
            </div>
            <div className={styles.blankDiv}></div>
            <main className={`${styles.mainContainer} container`}>
              <Filters
                data={content}
               
                clearALLFilter={clearALLFilter}
                initialStates={initialStates}
                state={state}
                setState={setState}
                reset ={reset}
                setReset = {setReset}
              />
              <div className={styles.filtergray}>
                {!Object.values(state).every(x => (x == "")) && Object.keys(state).length > 0 ? <div className={styles.filtercontent}>
                  {Object.keys(state).map((keyname, i) =>
                    state[keyname] == "" || state[keyname] == null ? null : (
                      <div className={`${styles.labelfilter}`} key={i}>
                        <p>{state[keyname]}</p>
                        <Icons
                          name="grayclose"
                          className={styles.closeicon}
                          onClick={() => removeFilter(keyname)}
                        />
                      </div>
                    )
                  )}
                </div> : null}
                <div
                  className={
                    allBots.length != 0
                      ? styles.cardContainer
                      : styles.noresultsmain
                  }
                >
                  {loading ? 
                    <Loader parent={"botStore"} /> : null}
                   
                   {allBots.length != 0 ? (
                    allBots.map((item, index) => (
                      <div key={index} className={styles.card}>
                        {" "}
                        <Dbotcard data={item} key={index} />
                      </div>
                    ))
                  ) : noResultFlag ?  (
                    <div className={styles.noresults}>
                      {/* fix this */}
                      <img
                        src={`${endpoints.drupalIp}${_.get(
                          data[2],
                          "component.content.field_no_result_image[0].file_url",
                          ""
                        )}`}
                      />
                      <h3 className={styles.head}>
                        {" "}
                        {_.get(data[2], "component.content.field_title", "")}
                      </h3>
                      <div
                        className={styles.content}
                        dangerouslySetInnerHTML={{
                          __html: _.get(
                            data[2],
                            "component.content.field_details",
                            ""
                          ),
                        }}
                      ></div>
                    </div>
                  ) : null}
                </div>
              </div>
            </main>

            <div className={styles.mobileFilterBtn} onClick={() => setFilterActive(true)}>
              <span className={styles.btn}>
                <Icons name="filters" className={styles.filterIcon} />
            Filters<sup className={styles.filterCount}>{length>5 ? 5 : length}</sup>
              </span>
            </div>
          </div>
        </InfiniteScroll>
      </div>
      {filterActive ? (
        <MobileFilters
          filterMobileData={content.field_bot_store_filters_fields.filter((item) => item.field_label != "Search")}
          setState={setState}
          setFilterActive={setFilterActive}
          previousState={state}
          mobileFilterRelatedInfo={mobileFilterRelatedInfo}
          setMobileFilterRelatedInfo={setMobileFilterRelatedInfo}
          setLength = {setLength}
          length = {length}
          setFilterOn={setFilterOn}
          initialState = {initialStates}
         // initialState={{kfa : true}}
        />
      ) : null}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    storeBot: state.storeBot,
  };
};

export default connect(mapStateToProps, null)(index);
